import { useNavigate } from 'react-router-dom';
import { clearPendingCheckouts } from '../utils/checkoutPending';

export default function CheckoutCancel() {
  const navigate = useNavigate();

  const handleBack = () => {
    clearPendingCheckouts();
    navigate('/');
  };

  return (
    <div className="max-w-md mx-auto py-12 px-4 text-center">
      <div className="rounded-2xl bg-amber-100 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 p-8">
        <h1 className="text-2xl font-semibold text-amber-800 dark:text-amber-200 mb-4">
          Checkout cancelled
        </h1>
        <p className="text-lg text-amber-700 dark:text-amber-300 mb-6">
          Any vendors you already paid are still in My Purchases. Unpaid items stay in your cart.
        </p>
        <button
          type="button"
          onClick={handleBack}
          className="px-6 py-3 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
        >
          Back to marketplace
        </button>
      </div>
    </div>
  );
}
